import {
  getUserData,
  getById,
  createDBConn,
  writeItem,
  Database,
} from './db';

import {UserInfo, Contact, ChatMessage} from '../types';

import uuid from 'react-native-uuid';

import {faker} from '@faker-js/faker';
import {Evolu} from '@evolu/common';

export const sendChatMessage = async (
  chatId: string,
  text: string,
  mnemonic: string,
  message = {},
) => {
  const u: UserInfo = await getUserData();
  const id = uuid.v4();
  const data = {
    id,
    text,
    userId: u.id,
    chatId,
    folderId: chatId,
    messageStatus: 'sent',
    userName: u.name,
    createdAt: new Date().valueOf(),
  };
  const ndata = {...data, ...message};
  console.info('send message', ndata);
  const nEvolu = await createDBConn(chatId, mnemonic);
  await writeItem(ndata, nEvolu);
  return ndata;
};

export const getPublicMessages = async (
  chatId: string,
  mnemonic: string,
  limit: number = 15,
  offset: number = 0,
) => {
  try {
    const folder = (await getById(chatId)) as Contact;
    let e: Evolu<Database> | undefined;
    if ((folder && folder.mnemonic) || mnemonic) {
      e = await createDBConn(
        chatId,
        folder?.mnemonic || mnemonic,
        true,
      );
    }
    const query = e?.createQuery(db =>
      db
        .selectFrom('item')
        .selectAll()
        .where('chatId', '=', chatId)
        .orderBy('createdAt', 'desc')
        .limit(limit)
        .offset(offset),
    );
    const data = query && (await e?.loadQuery(query));
    return data?.rows?.map(i => i.item as ChatMessage);
  } catch (err) {
    console.error('getPublicMessages error', err);
  }
  return [];
};

export const createNewParty = async (party: Contact) => {
  console.info('createNewParty', party);
  const user = await getUserData();
  const chatId = party.id;
  const contact = {
    ...party,
    id: chatId,
    authorId: user.id,
    authorName: user.name,
    isContact: true,
    mnemonic: party.mnemonic || genMnemonic(),
  };
  const item = await writeItem(contact);
  await sendChatMessage(
    chatId,
    user.name + ' has created chat ' + party.name,
    contact.mnemonic,
    {system: true},
  );
  return contact;
};

export const genMnemonic = () => {
  return [
    faker.animal.bird().split(' ').join('').toLowerCase(),
    faker.animal.bird().split(' ').join('').toLowerCase(),
    faker.color.human().split(' ').join('').toLowerCase(),
    faker.color.human().split(' ').join('').toLowerCase(),
    faker.color.human().split(' ').join('').toLowerCase(),
    faker.animal.fish().split(' ').join('').toLowerCase(),
    faker.animal.fish().split(' ').join('').toLowerCase(),
    faker.animal.fish().split(' ').join('').toLowerCase(),
    faker.animal.insect().split(' ').join('').toLowerCase(),
    faker.hacker.noun().split(' ').join('').toLowerCase(),
    faker.hacker.noun().split(' ').join('').toLowerCase(),
    faker.hacker.noun().split(' ').join('').toLowerCase(),
  ].join(' ');
};
